import { Header } from "@/components/site/Header";
import { HeroSection } from "@/components/site/HeroSection";
import { Services } from "@/components/site/Services";
import { Specials } from "@/components/site/Specials";
import { WorkGallery } from "@/components/site/WorkGallery";
import { BeforeAfter } from "@/components/site/BeforeAfter";
import { About } from "@/components/site/About";
import { BookVisit } from "@/components/site/BookVisit";
import { QuoteForm } from "@/components/site/QuoteForm";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Header />
      <HeroSection />
      <Services />
      <Specials />
      <BeforeAfter />
      <WorkGallery />
      <About />
      <BookVisit />
      <QuoteForm />
      <Footer />
    </div>
  );
}
